const contactFormConfig = {
  heading: "Contact Form",
  privacyPolicy: "Kohler Privacy Policy",
  url: "https://www.kohlercompany.com/privacy/",
  thankYouMessage: "Thank you for your enquiry! We will get back to you soon.",
  formFields: [
    {
      type: "select",
      name: "request_type",
      label: "Select Request Type",
      options: [
        "After sales service",
        "Commercial enquire",
        "Product information",
        "Promotion",
        "Others",
      ],
      required: true,
    },
    {
      type: "text",
      name: "first_name",
      label: "First Name",
      required: true,
    },
    {
      type: "text",
      name: "last_name",
      label: "Last Name",
      required: true,
    },
    {
      type: "email",
      name: "email",
      label: "Email Address",
      required: true,
    },
    {
      type: "text",
      name: "phone",
      label: "Mobile Number",
      required: true,
    },
    {
      type: "textarea",
      name: "message",
      label: "Please Describe Your Request",
      required: true,
    },
  ],
}

export default contactFormConfig
